import React from 'react';

interface EmptyStateProps {
    message: string;
    height?: string;
    className?: string;
}

// 🎯 Componente presentacional para estado vacío - SRP
export const EmptyState: React.FC<EmptyStateProps> = ({
    message,
    height = '300px',
    className = ''
}) => {
    return (
        <div
            className={`w-full border rounded-[10px] overflow-hidden ${className} flex items-center justify-center`}
            style={{ height }}
        >
            <div className="text-center">
                <div className="text-muted-foreground text-sm">
                    {message}
                </div>
            </div>
        </div>
    );
}; 